var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialogExamine },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "info_subject" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject_option" },
                    [
                      _c("div", { staticClass: "info_subject_option_title" }, [
                        _vm._v("开始周期"),
                      ]),
                      _c("el-date-picker", {
                        staticStyle: { width: "532px", height: "36px" },
                        attrs: {
                          type: "month",
                          "value-format": "yyyy/MM",
                          format: "yyyy/MM",
                          placeholder: "选择日期",
                          "picker-options": _vm.pickerOptions,
                        },
                        on: { change: _vm.ExamineChange },
                        model: {
                          value: _vm.dialogExamine.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogExamine, "date", $$v)
                          },
                          expression: "dialogExamine.date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "info_subject" }, [
                  _c("div", { staticClass: "info_subject_option" }, [
                    _c("div", { staticClass: "info_subject_option_title" }, [
                      _vm._v("考核人员"),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "users_personnel",
                        staticStyle: { margin: "0" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap",
                            },
                          },
                          _vm._l(
                            _vm.dialogExamine.userList,
                            function (item, index2) {
                              return _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.dialogExamine.userList &&
                                        _vm.dialogExamine.userList.length > 0,
                                      expression:
                                        "\n                  dialogExamine.userList &&\n                    dialogExamine.userList.length > 0\n                ",
                                    },
                                  ],
                                  key: index2,
                                  staticClass: "user_personnel",
                                  on: {
                                    click: function ($event) {
                                      return _vm.contactCh(
                                        _vm.dialogExamine.userList,
                                        "1"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "info_personnel" },
                                    [
                                      item.avatar != "" && item.avatar !== null
                                        ? _c("img", {
                                            staticClass:
                                              "info_personnel_surname",
                                            attrs: { src: item.avatar },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "info_personnel_surname",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.name.substring(0, 1)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                      _vm.channel === "wechat"
                                        ? _c(
                                            "div",
                                            { staticClass: "name_style" },
                                            [
                                              _c("ww-open-data", {
                                                attrs: {
                                                  type: "userName",
                                                  openid: item.name,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: item.name,
                                                placement: "bottom-start",
                                                "open-delay": 500,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "name_style" },
                                                [_vm._v(_vm._s(item.name))]
                                              ),
                                            ]
                                          ),
                                    ],
                                    1
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shanchu del_icon",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.delUsers(
                                          _vm.dialogExamine.userList,
                                          index2,
                                          "1"
                                        )
                                      },
                                    },
                                  }),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _c("i", {
                          staticClass: "iconfont icon-jiahao2fill add_icon",
                          staticStyle: { margin: "5px 0 0 10px" },
                          on: {
                            click: function ($event) {
                              return _vm.contactCh(
                                _vm.dialogExamine.userList,
                                "1"
                              )
                            },
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "info_subject" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject_option" },
                    [
                      _c("div", { staticClass: "info_subject_option_title" }, [
                        _vm._v("评分模版"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "532px", height: "36px" },
                          attrs: { placeholder: "请选择评分模版" },
                          on: { change: _vm.templateChange },
                          model: {
                            value: _vm.dialogExamine.templateValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogExamine, "templateValue", $$v)
                            },
                            expression: "dialogExamine.templateValue",
                          },
                        },
                        _vm._l(
                          _vm.dialogExamine.templateOptions,
                          function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "info_subject" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject_option" },
                    [
                      _c("div", { staticClass: "info_subject_option_title" }, [
                        _vm._v("评分流程"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "532px", height: "36px" },
                          attrs: { placeholder: "请选择评分流程" },
                          on: { change: _vm.followChange },
                          model: {
                            value: _vm.dialogExamine.followValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogExamine, "followValue", $$v)
                            },
                            expression: "dialogExamine.followValue",
                          },
                        },
                        _vm._l(
                          _vm.dialogExamine.followOptions,
                          function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm.roleData && _vm.roleData.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.roleData, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "info_subject" },
                          [
                            _c(
                              "div",
                              { staticClass: "info_subject_option" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: item.name,
                                      placement: "bottom-start",
                                      "open-delay": 500,
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "info_subject_option_title",
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "users_personnel",
                                    staticStyle: { margin: "0" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-wrap": "wrap",
                                        },
                                      },
                                      _vm._l(
                                        item.userList,
                                        function (itemF, index2) {
                                          return _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    item.userList &&
                                                    item.userList.length > 0,
                                                  expression:
                                                    "\n                    item.userList &&\n                      item.userList.length > 0\n                  ",
                                                },
                                              ],
                                              key: index2,
                                              staticClass: "user_personnel",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.contactCh(
                                                    item.userList,
                                                    item.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "info_personnel",
                                                },
                                                [
                                                  itemF.avatar != "" &&
                                                  itemF.avatar != null
                                                    ? _c("img", {
                                                        staticClass:
                                                          "info_personnel_surname",
                                                        attrs: {
                                                          src: itemF.avatar,
                                                        },
                                                      })
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info_personnel_surname",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                itemF.name.substring(
                                                                  0,
                                                                  1
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                  _vm.channel === "wechat"
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "name_style",
                                                        },
                                                        [
                                                          _c("ww-open-data", {
                                                            attrs: {
                                                              type: "userName",
                                                              openid:
                                                                itemF.name,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            effect: "dark",
                                                            content: itemF.name,
                                                            placement:
                                                              "bottom-start",
                                                            "open-delay": 500,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "name_style",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  itemF.name
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-shanchu del_icon",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.delUsers(
                                                      item,
                                                      index2,
                                                      "2"
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-jiahao2fill add_icon",
                                      staticStyle: { margin: "5px 0 0 10px" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.contactCh(
                                            item.userList,
                                            item.id
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialogInitiate },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "info_subject",
                    staticStyle: { "min-height": "260px", width: "100%" },
                  },
                  [
                    _vm.dialogInitiate.tableData.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass: "table-box",
                            staticStyle: { width: "98%" },
                          },
                          [
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: _vm.dialogInitiate.tableData,
                                  "header-cell-style": {
                                    background: "#F1F1F1 ",
                                    fontSize: "14px",
                                    colorr: "#999999",
                                  },
                                  border: "",
                                  "span-method": _vm.objectSpanMethod,
                                  "cell-class-name": _vm.getCellClassName,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "typeName",
                                    label: "分类",
                                    width: "150",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "100%",
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.typeName)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  width: "100%",
                                                  "text-align": "center",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(scope.row.typeScore) +
                                                    "%"
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3378591541
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "content",
                                    label: "考核内容",
                                    "min-width": "200",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content: scope.row.content,
                                                  placement: "bottom",
                                                  "popper-class": "texttooltip",
                                                  "open-delay": 500,
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(scope.row.content)
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2326018757
                                  ),
                                }),
                                _vm._l(
                                  _vm.tableHeaders,
                                  function (header, index) {
                                    return _c("el-table-column", {
                                      key: index,
                                      attrs: {
                                        prop: header.name,
                                        "min-width": "200",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "header",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "template_header",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          overflow: "hidden",
                                                          "text-overflow":
                                                            "ellipsis",
                                                          "white-space":
                                                            "nowrap",
                                                        },
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            header.label
                                                          ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(header.label)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.fieldValueMap
                                                  ? _c("div", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            scope.row
                                                              .fieldValueMap[
                                                              header.prop
                                                            ]
                                                          ) +
                                                          " "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  }
                                ),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "score",
                                    label: "分值",
                                    width: "100",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.type === "0"
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.taskNormalScore
                                                    )
                                                  ),
                                                ])
                                              : _c("div", [
                                                  _vm._v(
                                                    _vm._s(scope.row.score)
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3824937655
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "controls",
                                    label: "操作",
                                    width: "100",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      effect: "dark",
                                                      content: "添加考核",
                                                      placement: "top",
                                                      "popper-class":
                                                        "texttooltip",
                                                    },
                                                  },
                                                  [
                                                    scope.row.type !== "0"
                                                      ? _c("i", {
                                                          staticClass:
                                                            "iconfont icon-jiahao2fill icon_btn",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.handleEdit(
                                                                scope.$index,
                                                                scope.row
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      effect: "dark",
                                                      content: "删除",
                                                      placement: "top",
                                                      "popper-class":
                                                        "texttooltip",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "iconfont icon-shanchu1 icon_btn",
                                                      staticStyle: {
                                                        "font-size": "15px",
                                                        "padding-left": "10px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.handleDelete(
                                                            scope.$index,
                                                            scope.row
                                                          )
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3811470164
                                  ),
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _c("div", [_c("noDate")], 1),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialogaddExamine },
        on: { dialogVisible: _vm.cancelDialog2 },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c("div", { staticClass: "info_subject" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject_option" },
                    [
                      _c("div", { staticClass: "info_subject_option_title" }, [
                        _vm._v("考核分类"),
                      ]),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "532px" },
                          attrs: { placeholder: "请选择考核分类" },
                          on: { change: _vm.sortSelect },
                          model: {
                            value: _vm.dialogaddExamine.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.dialogaddExamine, "sort", $$v)
                            },
                            expression: "dialogaddExamine.sort",
                          },
                        },
                        _vm._l(
                          _vm.dialogaddExamine.sortOptions,
                          function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "info_subject" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject_option" },
                    [
                      _c("div", { staticClass: "info_subject_option_title" }, [
                        _vm._v("说明"),
                      ]),
                      _c("el-input", {
                        staticClass: "area",
                        staticStyle: { width: "532px" },
                        attrs: {
                          type: "textarea",
                          placeholder: "请输入考核内容",
                        },
                        on: { change: _vm.FinstandardChange },
                        model: {
                          value: _vm.dialogaddExamine.standard,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogaddExamine, "standard", $$v)
                          },
                          expression: "dialogaddExamine.standard",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm.dialogaddExamine.fieldValueList &&
                _vm.dialogaddExamine.fieldValueList.length > 0
                  ? _c(
                      "div",
                      _vm._l(
                        _vm.dialogaddExamine.fieldValueList,
                        function (item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "info_subject" },
                            [
                              _c(
                                "div",
                                { staticClass: "info_subject_option" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "info_subject_option_title",
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _c("el-input", {
                                    staticStyle: { width: "532px" },
                                    attrs: {
                                      type: "text",
                                      placeholder: "请输入",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.tempFieldsChange(
                                          $event,
                                          item,
                                          index,
                                          _vm.dialogaddExamine.fieldValueList
                                        )
                                      },
                                    },
                                    model: {
                                      value: item.value,
                                      callback: function ($$v) {
                                        _vm.$set(item, "value", $$v)
                                      },
                                      expression: "item.value",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                _c("div", { staticClass: "info_subject" }, [
                  _c(
                    "div",
                    { staticClass: "info_subject_option" },
                    [
                      _c("div", { staticClass: "info_subject_option_title" }, [
                        _vm._v("分值"),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "532px" },
                        attrs: { min: 0, type: "number" },
                        model: {
                          value: _vm.dialogaddExamine.score,
                          callback: function ($$v) {
                            _vm.$set(_vm.dialogaddExamine, "score", $$v)
                          },
                          expression: "dialogaddExamine.score",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("Dialogs", {
        attrs: { dialogs: _vm.dialogFinsh },
        on: { dialogVisible: _vm.beforeClose },
        scopedSlots: _vm._u([
          {
            key: "desc",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "info_finsh",
                    staticStyle: { height: "700px" },
                  },
                  [
                    _vm.dialogFinsh.tableData.length > 0
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: _vm.dialogFinsh.tableData,
                                  "header-cell-style": {
                                    background: "#F1F1F1 ",
                                    fontSize: "14px",
                                    cursor: "pointer",
                                    colorr: "#999999",
                                  },
                                  "row-style": { height: "38" },
                                  "cell-class-name": _vm.returnName,
                                },
                              },
                              [
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "projectName",
                                    label: "项目名称",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content:
                                                    scope.row.projectName,
                                                  placement: "bottom",
                                                  "popper-class": "texttooltip",
                                                  "open-delay": 500,
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.projectName
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1982795333
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "taskname",
                                    label: "任务名称",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-tooltip",
                                              {
                                                attrs: {
                                                  effect: "dark",
                                                  content: scope.row.taskname,
                                                  placement: "bottom",
                                                  "popper-class": "texttooltip",
                                                  "open-delay": 500,
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(scope.row.taskname)
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3726233605
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: { prop: "score", label: "负责人" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.responseUserList &&
                                            scope.row.responseUserList.length >
                                              0
                                              ? _c(
                                                  "div",
                                                  _vm._l(
                                                    scope.row.responseUserList,
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        { key: index },
                                                        [
                                                          _vm.channel ===
                                                          "wechat"
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _c(
                                                                    "ww-open-data",
                                                                    {
                                                                      attrs: {
                                                                        type: "userName",
                                                                        openid:
                                                                          item.name,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                ),
                                                              ]),
                                                          _c(
                                                            "span",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    scope.row
                                                                      .responseUserList
                                                                      .length -
                                                                      1 !=
                                                                    index,
                                                                  expression:
                                                                    "scope.row.responseUserList.length-1!=index",
                                                                },
                                                              ],
                                                            },
                                                            [_vm._v(",")]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2094963273
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "status",
                                    label: "任务状态",
                                    width: "120",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            scope.row.taskType === "1"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "scope-content",
                                                  },
                                                  [
                                                    scope.row.status === "0"
                                                      ? _c("span", [
                                                          _vm._v("未开始"),
                                                        ])
                                                      : _vm._e(),
                                                    scope.row.status === "1"
                                                      ? _c("span", [
                                                          _vm._v("未完成"),
                                                        ])
                                                      : _vm._e(),
                                                    scope.row.status === "2"
                                                      ? _c("span", [
                                                          _vm._v("已完成"),
                                                        ])
                                                      : _vm._e(),
                                                    scope.row.status === "3"
                                                      ? _c("span", [
                                                          _vm._v("待确认"),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : scope.row.taskType === "0"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "scope-content",
                                                  },
                                                  [
                                                    scope.row.status === "0"
                                                      ? _c("span", [
                                                          _vm._v("未指派"),
                                                        ])
                                                      : _vm._e(),
                                                    scope.row.status === "1"
                                                      ? _c("span", [
                                                          _vm._v("未完成"),
                                                        ])
                                                      : _vm._e(),
                                                    scope.row.status === "2"
                                                      ? _c("span", [
                                                          _vm._v("已完成"),
                                                        ])
                                                      : _vm._e(),
                                                    scope.row.status === "3"
                                                      ? _c("span", [
                                                          _vm._v("待确认"),
                                                        ])
                                                      : _vm._e(),
                                                    scope.row.status === "4"
                                                      ? _c("span", [
                                                          _vm._v("已终止"),
                                                        ])
                                                      : _vm._e(),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2991789461
                                  ),
                                }),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "score",
                                    label: "绩效",
                                    width: "100",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("div", [
                                              _vm._v(_vm._s(scope.row.score)),
                                            ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2349089753
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c("div", [_c("noDate")], 1),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }